
import React from 'react';

const StageProcess = ({ stages }) => {
    const [loaded, setLoaded] = React.useState(false);

    React.useEffect(() => {
        const timer = setTimeout(() => {
            setLoaded(true);
        }, 100);
        return () => clearTimeout(timer);
    }, []);

    return (
        <div className="bg-white p-6 rounded-2xl shadow-md border border-gray-100 min-h-[400px]">
            <h3 className="font-bold text-lg text-gray-900 mb-6">Stage Process (Monthly)</h3>

            <div className="space-y-6">
                {stages && stages.length > 0 ? (
                    stages.map((stage, index) => (
                        <div key={index}>
                            <div className="flex justify-between items-center mb-2">
                                <span className="text-gray-900 font-medium">{stage.name}</span>
                                <div className="text-[10px] sm:text-xs">
                                    <span className="text-gray-400 mr-2">Plan: {Math.round(Number(stage.planned) || 0)}%</span>
                                    <span className="font-semibold text-gray-900">Actual: {Math.round(Number(stage.actual) || 0)}%</span>
                                </div>
                            </div>
                            {/* Progress Bar Container */}
                            <div className="h-2 w-full bg-gray-100 rounded-full overflow-hidden relative">
                                {/* Actual Progress Bar */}
                                <div
                                    className="h-full rounded-full absolute left-0 top-0 z-10 transition-all duration-1000 ease-out"
                                    style={{
                                        width: loaded ? `${Math.round(Number(stage.actual) || 0)}%` : '0%',
                                        backgroundColor: stage.color
                                    }}
                                />
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="flex flex-col items-center justify-center py-12 px-4">
                        {/* Icon */}
                        <div className="w-16 h-16 mb-4 rounded-full bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                            <svg
                                className="w-8 h-8 text-blue-400"
                                fill="none"
                                stroke="currentColor"
                                viewBox="0 0 24 24"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"
                                />
                            </svg>
                        </div>

                        {/* Main Message */}
                        <h4 className="text-gray-900 font-semibold text-base mb-2">
                            No Stage Progress Data
                        </h4>

                        {/* Descriptive Text */}
                        <p className="text-gray-500 text-sm text-center max-w-xs">
                            Stage progress information will appear here once construction activities are tracked for the selected month and project.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default StageProcess;
